import React, { useState } from "react";
import Quiz from "./components/Quiz";
import Home from "./components/Home";
import QuizEntry from "./components/QuizEntry";
import "./index.css";

import logo from "./assets/logo_scaled.png";

export function App() {
  const [username, setUsername] = useState(localStorage.getItem("quiz_username") || "");
  const [userId, setUserId] = useState(localStorage.getItem("quiz_user_id") || "");
  // Simple router based on window.location
  const path = window.location.pathname;

  const handleJoin = async (newUsername: string) => {
    const storedUserId = localStorage.getItem("quiz_user_id");

    if (storedUserId) {
      // Update existing user's username
      const res = await fetch(`/api/user/${storedUserId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: newUsername }),
      });
      if (res.ok) {
        localStorage.setItem("quiz_username", newUsername);
        setUsername(newUsername);
      }
    } else {
      // Create new user
      const res = await fetch("/api/user", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: newUsername }),
      });
      if (res.ok) {
        const user = await res.json();
        localStorage.setItem("quiz_user_id", user.id);
        localStorage.setItem("quiz_username", newUsername);
        setUserId(user.id);
        setUsername(newUsername);
      }
    }
  };

  const handleChangeUser = () => {
    localStorage.removeItem("quiz_username");
    setUsername("");
  };

  let content;
  if (path === "/") {
    content = <Home />;
  } else if (path.startsWith("/quiz/")) {
    const quizId = path.split("/")[2] || "";

    if (username) {
      content = <Quiz quizId={quizId} username={username} onChangeUser={handleChangeUser} />;
    } else {
      content = <QuizEntry onJoin={handleJoin} />;
    }
  } else {
    content = <div className="text-center mt-20 text-red-500">Sayfa bulunamadı</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="text-center mb-8">
        <img
          src={logo}
          alt="TUS Wars Logo"
          className="mx-auto h-32 w-auto object-contain hover:scale-105 transition-transform duration-300 drop-shadow-sm"
        />
      </div>
      {content}
    </div>
  );
}

export default App;
